module.exports = __webpack_public_path__ + "static/media/DocumentReceived.096496ba.svg";